import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {
    AddressBANFeature,
    Point,
    ProjectsService as SdkProjectsService,
    SearchEntity,
    SearchEntityData,
} from '@connect-services/client/sdk/api';

export class SearchEntityWithSource implements SearchEntity {
    public data!: SearchEntityData;
    public id!: string;
    public name!: string;
}

export type AddressBANResult = {
    geometry: Point;
    id: string;
    label: string;
};

@Injectable({
    providedIn: 'root',
})
export class MapSearchService {
    public readonly selectedAddressItem: WritableSignal<AddressBANResult | undefined> = signal(undefined);
    public readonly selectedSearchItem: WritableSignal<SearchEntityWithSource | undefined> = signal(undefined);

    private readonly projectService = inject(SdkProjectsService);

    public getAddressBAN(projectId: string, searchValue: string): Promise<AddressBANFeature[]> {
        return firstValueFrom(
            this.projectService.projectControllerSearchBAN({
                id: projectId,
                value: searchValue,
            }),
        );
    }

    public getSearchData(projectId: string, searchValue: string, layerNames: string[]): Promise<SearchEntity[]> {
        return firstValueFrom(
            this.projectService.projectControllerSearch({
                id: projectId,
                layerNames: layerNames.length ? layerNames : undefined,
                take: 5,
                value: searchValue,
            }),
        );
    }
}
